module.exports = __webpack_public_path__ + "img/矩形 2580.fba87d4d.png";